/* eslint-disable no-console */
import React from 'react';
import { Login, Logout } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { ZendeskOauthClient } from '../../features/auth/ZendeskOauthClient';
import {
  setLoggedIn, setLoggedOut, setUserInfo, setUserOrganizations,
} from '../../features/auth/zendeskSlice';
import { useAppDispatch, useAppSelector } from '../hooks';

const useStyles = makeStyles(() => createStyles({
  loginRoot: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  loginIcon: {
    marginLeft: 15,
    marginRight: 30,
    color: 'white',
  },
}));

export default function ZendeskAccount() {
  const dispatch = useAppDispatch();

  const classes = useStyles();
  const zendeskEndpoint = 'https://vertigis.zendesk.com';

  let client = new ZendeskOauthClient(zendeskEndpoint);
  const clientId = 'changelogs_frontend';

  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);
  const userInfo = useAppSelector((state) => state.auth.userInfo);

  const onToggleLoginClick = async () => {
    if (isLoggedIn) {
      await zendeskLogout();
    } else {
      await zendeskLogin();
    }
  };

  const zendeskLogin = async () => {
    const success = await client.login(clientId);
    if (success && client.accessToken) {
      dispatch(setLoggedIn({ success, accessToken: client.accessToken }));
    }

    if (success) {
      const info = await client.getUserInfo();
      dispatch(setUserInfo(info));

      const organizations = await client.getUserOrganizations(info.id);
      dispatch(setUserOrganizations(organizations));
    }
  };

  const zendeskLogout = async () => {
    client = new ZendeskOauthClient(zendeskEndpoint);
    dispatch(setLoggedOut());
  };

  return (
    <div className={classes.loginRoot}>
      {isLoggedIn && userInfo && (
        <span style={{ color: 'white', marginRight: 10, textWrap: 'nowrap' }}>
          {userInfo.name}
        </span>
      )}
      <Tooltip
        title={isLoggedIn ? 'Logout' : 'Login with your VertiGIS Support Center account for more options!'}
        placement="bottom"
      >
        <IconButton
          className={classes.loginIcon}
          color="inherit"
          aria-label="Zendesk Login"
          onClick={onToggleLoginClick}
        >
          {isLoggedIn ? <Logout /> : <Login />}
        </IconButton>
      </Tooltip>
    </div>
  );
}
